var _link, _link2, _style, _style2, _style3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg10",
    fill: "none",
    height: 279.60699,
    preserveAspectRatio: "xMinYMid slice",
    viewBox: "0 0 600.00018 279.60699",
    width: 600.00018,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m141.87056 195.61392l-19.29249 19.98151c-2.75607 3.44508-6.89017 2.75607-10.33526 0l-68.21274-69.59077v64.76764c0 4.13411-2.75607 6.89018-7.57919 6.89018h-27.5607c-4.1341 0-6.89018-2.75607-6.89018-6.89018v-201.88213c0-4.13411 2.75608-6.89017 6.89018-6.89017h27.5607c4.82312 0 7.57919 2.75606 7.57919 6.89017v66.145683h93.01737c4.13411 0 6.89017 2.75607 6.89017 6.890175v28.249722c0 4.1341-2.75606 6.89017-6.89017 6.89017h-63.38961l68.21273 68.90175c2.75607 2.75607 2.75607 6.20116 0 9.64625z",
    fill: "#000",
    strokeWidth: 6.89017534
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "m294.83245 146.00466c0 2.75607-.68902 6.20115-.68902 8.95723-.68902 4.1341-3.44509 6.20115-7.57919 6.20115h-92.32835c4.82312 12.40232 16.53642 20.67053 32.38383 20.67053 10.33526 0 19.29249-4.13411 25.49364-11.02428 2.75607-3.44509 5.51214-4.13411 9.64625-2.06705l21.35954 13.09133c3.44509 2.75607 4.82312 6.20116 2.06705 9.64624-13.09133 17.91446-34.45087 28.93874-59.2555 28.93874-42.71909 0-73.72488-31.69481-73.72488-73.72488 0-42.71908 29.62776-75.102904 70.96881-75.102904 42.71908 0 71.65782 31.694804 71.65782 74.413894zm-41.34105-15.15839c-4.13411-13.09133-15.15839-20.67052-29.62776-20.67052-15.8474 0-26.87168 7.57919-30.31677 20.67052z",
    fill: "#000",
    strokeWidth: 6.89017534
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m434.01398 128.0902v82.6821c0 4.13411-2.06705 6.89018-6.89017 6.89018h-26.87168c-4.1341 0-6.89018-2.75607-6.89018-6.89018v-8.26821c-11.02428 12.40232-23.4266 17.91446-39.27399 17.91446-31.00579 0-51.67632-17.22544-51.67632-44.09712 0-28.24972 20.67053-46.16418 50.9873-46.16418h39.96301v-3.44508c0-9.64625-9.64624-16.53642-23.4266-16.53642-8.95722 0-17.91445 3.44508-22.04855 8.26821-2.75607 2.75607-4.13411 4.82312-8.26821 4.82312h-26.18267c-4.82312 0-7.57919-2.75607-6.89017-6.89018 5.51214-26.871679 28.24972-44.786134 62.70059-44.786134 39.27399 0 64.76764 22.737578 64.76764 56.499434zm-40.65203 36.51793v-4.82312h-33.76185c-11.02428 0-15.84741 6.20116-15.84741 13.78035 0 7.57919 6.20116 13.78035 20.67053 13.78035 17.22543 0 28.93873-9.64625 28.93873-22.73758z",
    fill: "#000",
    strokeWidth: 6.89017534
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m598.00016 146.69367c0 41.34106-28.93874 73.72488-67.52372 73.72488-15.84741 0-29.62776-5.51214-37.89597-15.8474v66.14568c0 4.13411-2.75606 6.89017-7.57919 6.89017h-27.5607c-4.1341 0-6.89018-2.75606-6.89018-6.89017v-188.790802c0-4.134105 2.75608-6.890175 6.89018-6.890175h26.87168c4.82312 0 6.89018 2.75607 6.89018 6.890175v8.26821c8.95723-11.713297 22.73758-18.603472 38.58498-18.603472 38.58498 0 68.21274 33.072844 68.21274 75.102904zm-42.03007 0c0-19.29249-13.09134-33.76185-31.6948-33.76185-19.98152 0-33.76186 14.46936-33.76186 33.76185 0 18.60348 13.78034 33.07285 33.76186 33.07285 18.60346 0 31.6948-14.46937 31.6948-33.07285z",
    fill: "#000",
    strokeWidth: 6.89017534
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeap);
export default __webpack_public_path__ + "static/media/keap.262234279a929684dfa975a55ad97de8.svg";
export { ForwardRef as ReactComponent };